import { render, staticRenderFns } from "./FilesComponent.vue?vue&type=template&id=0dff5366&scoped=true&"
import script from "./FilesComponent.vue?vue&type=script&lang=js&"
export * from "./FilesComponent.vue?vue&type=script&lang=js&"
import style0 from "./FilesComponent.vue?vue&type=style&index=0&id=0dff5366&lang=scss&scoped=true&"
import style1 from "./FilesComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff5366",
  null
  
)

export default component.exports